export const START_GOALS_LOAD = 'START_GOALS_LOAD';
export const FINISH_GOALS_LOAD = 'FINISH_GOALS_LOAD';
export const GOALS_ERROR = 'GOALS_ERROR';
export const START_GOAL_ACTION_REQUEST = 'START_GOAL_ACTION_REQUEST';
export const FINISH_GOAL_ACTION_REQUEST = 'FINISH_GOAL_ACTION_REQUEST';
export const CB2_RR_UPSELL_GOALS = 'CB2_RR_Upsell_Goals';
export const CB2_RR_UPSELL_GOALS_RR = 'CB2_RR_Upsell_Goals_RR';
export const CB2_RR_UPSELL_GOALS_CB2 = 'CB2_RR_Upsell_Goals_CB2';
export const CB_RR_OPTIMIZELY_RULE = 'CB RR Upsell Rules';
